import {
  INIT_APP3,
  INIT_APP3_SUCCESS,
  APP3_OFFLINE,
  LOAD_CONFIGURATION3_SUCCESS,
  LOAD_HTMLTEMPLATES3_SUCCESS,
  RECONNECT3_SUCCESS,
  ERROR,
  WARNING,
  CONFIRM_WARNING,
  RESUME_TICKET,
  CLEAR_RESUME_TICKET,
  SET_PAGE_TITLE,
  SET_MODAL_CONTENT,
} from "../constants";
import produce from "immer";

const initialState = {
  initApp: false,
  configuration: null,
  error: null,
  warning: null,
  orgName: null,
  isOffline: false,
  modalContent: null,
};

const app3Reducer = produce((draft, action) => {
  switch (action.type) {
    case INIT_APP3: {
      draft.initApp = false;
      break;
    }
    case LOAD_HTMLTEMPLATES3_SUCCESS: {
      draft.htmlTemplates = action.templates;
      break;
    }
    case RECONNECT3_SUCCESS:
    case INIT_APP3_SUCCESS: {
      draft.initApp = true;
      draft.orgName = action.orgName;
      break;
    }
    case APP3_OFFLINE: {
      if (draft.isOffline) {
        window.location.reload();
      }
      draft.isOffline = action.isOffline;
      break;
    }
    case LOAD_CONFIGURATION3_SUCCESS: {
      draft.configuration = action.configuration;
      break;
    }
    case ERROR: {
      draft.error = action.error;
      break;
    }
    case WARNING: {
      draft.warning = action.warning;
      break;
    }
    case CONFIRM_WARNING: {
      delete draft.warning;
      break;
    }
    case RESUME_TICKET: {
      draft.resumeTicket = action;
      break;
    }
    case CLEAR_RESUME_TICKET: {
      delete draft.resumeTicket;
      break;
    }
    case SET_PAGE_TITLE: {
      draft.pageTitle = action.pageTitle;
      break;
    }
    case SET_MODAL_CONTENT: {
      draft.modalContent = action.modalContent;
      break;
    }
    default:
      break;
  }
}, initialState);

export default app3Reducer;

/* Getters */

export const getInitApp3Success = (state) => {
  return state.initApp;
};

export const getConfiguration3 = (state) => {
  return state.configuration;
};

export const getError = (state) => {
  return state.error;
};

export const getWarning = (state) => {
  return state.warning;
};

export const getHTMLTemplates3 = (state) => {
  return state.htmlTemplates;
};

export const getResumeTicket = (state) => {
  return state.resumeTicket;
};

export const getPageTitle = (state) => {
  return state.pageTitle;
};

export const getIsOffline = (state) => {
  return state.isOffline;
};

export const getModalContent = (state) => {
  return state.modalContent;
};
